import styled from 'styled-components'

type Props = {
  isOpen?: boolean;
}

const StyledLessonMap = styled.div<Props>`
  width: 400px;
  background: ${({ theme }) => theme.colors.gray[50]};
  font-family: ${({ theme }) => theme.fonts.lexend};
  border-left: 1px solid ${({ theme }) => theme.colors.gray[200]};
  position: fixed;
  top: 0;
  right: ${({ isOpen }) => isOpen ? '0' : '-450'}px;
  bottom: 0;
  border-radius: 3px;
  z-index: ${({ theme }) => theme.elevations.override};
  overflow-y: auto;
  transition: 0.2s;

  &::-webkit-scrollbar {
    display: none;
  }

  .map-header {
    padding: 25px;
    background: ${({ theme }) => theme.colors.background};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};

    .menu-collapse-btn {
      margin-top: -12px;
      margin-left: -16px;
      margin-bottom: 1rem;
      font-weight: 500;
    }

    .completion-bar {
      display: grid;
      width: 100%;
      grid-gap: 7px;
  
      label {
        font-weight: 400;
        font-size: 17px;
        letter-spacing: 0.1px;
        color: ${({ theme }) => theme.colors.gray[500]};
      }
  
      progress {
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        height: 8px;
        border-radius: 50rem;
        overflow: hidden;
  
        &::-webkit-progress-bar {
          background: ${({ theme }) => theme.colors.gray[100]};
        }
  
        &::-webkit-progress-value {
          border-radius: 50rem;
          background: ${({ theme }) => theme.colors.green[300]};
          transition: 0.2s;
        }
      }
    }
  }

  .lesson-map {
    display: grid;
  }
`

export default StyledLessonMap
